export default __webpack_public_path__ + "static/media/img-trabajo-8.decc00f5.jpg";